import MenuItem from '@mui/material/MenuItem'
import type { ReactNode } from 'react'

type AppMenuItemProps = {
  children: ReactNode
  className?: string
  disabled?: boolean
  onClick?: () => void
}

export function AppMenuItem({
  children,
  className,
  disabled = false,
  onClick,
}: AppMenuItemProps) {
  return (
    <MenuItem className={className} disabled={disabled} onClick={onClick}>
      {children}
    </MenuItem>
  )
}
